import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import Page from '../../components/Layout/Page';
import StudentInfo from './StudentInfo';
import { getEnrollmentSummaryByStudentId } from '../../requests/api/students';

const STAGE_ORDER = ['enrollment', 'study-plan', 'schedule', 'enrolled', 'paid', 'comments'];

function EnrollmentPending() {
  const routerLocation = useLocation();
  const history = useHistory();
  const { studentId } = useParams<{ studentId: string }>();
  const [initializedForStudentId, setInitializedForStudentId] = useState<string | null>(null);

  const getTabFromQuery = (search: string): 'informacion' | 'plan-estudios' => {
    const params = new URLSearchParams(search);
    return params.get('tab') === 'plan-estudios' ? 'plan-estudios' : 'informacion';
  };

  const [activeTab, setActiveTab] = useState<'informacion' | 'plan-estudios'>(() => getTabFromQuery(routerLocation.search));

  // Sincronizar tab con URL cuando cambia la URL (ej. navegación atrás)
  useEffect(() => {
    const tabFromQuery = getTabFromQuery(routerLocation.search);
    setActiveTab((prev) => (prev === tabFromQuery ? prev : tabFromQuery));
  }, [routerLocation.search]);

  // Tab inicial según stage (una vez por alumno): sin ?tab= y stage >= study-plan → plan-estudios
  useEffect(() => {
    if (!studentId || initializedForStudentId === studentId) return undefined;
    const hasTabInUrl = new URLSearchParams(routerLocation.search).get('tab') !== null;
    if (hasTabInUrl) {
      setInitializedForStudentId(studentId);
      return undefined;
    }

    let cancelled = false;
    getEnrollmentSummaryByStudentId(studentId)
      .then((res) => {
        if (cancelled) return;
        const stage = res?.student?.stage;
        if (!stage) {
          setInitializedForStudentId(studentId);
          return;
        }
        const stageIndex = STAGE_ORDER.indexOf(stage);
        const studyPlanIndex = STAGE_ORDER.indexOf('study-plan');
        if (stageIndex >= studyPlanIndex && studyPlanIndex !== -1) {
          handleTabChange('plan-estudios');
        }
        setInitializedForStudentId(studentId);
      })
      .catch(() => {
        if (!cancelled) setInitializedForStudentId(studentId);
      });

    return () => { cancelled = true; };
  }, [studentId, initializedForStudentId]);

  const handleTabChange = (tab: 'informacion' | 'plan-estudios') => {
    setActiveTab(tab);
    const params = new URLSearchParams(routerLocation.search);
    if (tab === 'informacion') {
      params.delete('tab');
    } else {
      params.set('tab', 'plan-estudios');
    }
    const searchString = params.toString();
    history.replace(`${routerLocation.pathname}${searchString ? `?${searchString}` : ''}`);
  };

  return (
    <Page title="Mi información">
      <StudentInfo
        tab={activeTab}
        onTabChange={handleTabChange}
      />
    </Page>
  );
}

export default EnrollmentPending;
